function getDeviceType() {
    var ua = navigator.userAgent;
    if (/tablet|ipad|playbook|silk/i.test(ua))
        return 'tablet';
    if (/mobile|android|iphone|ipod|blackberry|opera mini|iemobile/i.test(ua))
        return 'mobile';
    return 'desktop';
}
export function useDeviceInfo() {
    return {
        type: getDeviceType(),
        userAgent: navigator.userAgent,
        screenSize: "".concat(screen.width, "x").concat(screen.height),
    };
}
